import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogFormService } from 'src/app/services/dialog-form.service';
import { DialogAddClientComponent } from '../dialog-add-client/dialog-add-client.component';
import { DialogService } from 'src/app/services/dialog.service';
import { Company } from 'src/app/models/company';
import { AddClientDto } from 'src/app/models/dialog-dto/add-client.dto';
import {
  CompanyItemDto,
  CompanyListItemDto,
} from 'src/app/models/dialog-dto/company-list-item.dto';
import { CustomerItemDto } from 'src/app/models/dialog-dto/customer-list-item.dto';
import { Tag } from 'src/app/models/user';
import { DataService } from 'src/app/services/data.service';

interface AddCustomerDialogData {
  guid: string;
  client: string;
}

@Component({
  selector: 'app-dialog-add-customer',
  templateUrl: './dialog-add-customer.component.html',
  styleUrl: './dialog-add-customer.component.scss',
})
export class DialogAddCustomerComponent {
  guid: string = '';
  clientSelectForm: FormGroup;
  companyForm: FormGroup;

  initialClient: CompanyItemDto | undefined;
  initialCustomer: AddClientDto | undefined

  selectedTags : Tag[] = []

  constructor(
    public dialogService: DialogService,
    private dialogFormService: DialogFormService,
    public dialogRef: MatDialogRef<DialogAddClientComponent>,
    private dataService: DataService,
    @Inject(MAT_DIALOG_DATA) public data: AddCustomerDialogData
  ) {
    this.clientSelectForm = this.dialogFormService.newCompanySelectForm();
    this.companyForm = this.dialogFormService.newCompanyForm();

    if (data?.client) {
      this.dialogService.getSelectedClient(data.client).subscribe((client) => {
        this.clientSelectForm.get('id')?.setValue(client.company.id);
        this.initialClient = client;
      });
    }

    if (data?.guid) {
      this.guid = data.guid;
      this.dialogService
        .getEditCustomerData(data.guid)
        .subscribe((customer) => {
          this.initialCustomer = customer
          this.setInitialData(customer, this.companyForm);

          this.dialogService
            .getSelectedClient(customer.client.id)
            .subscribe((client) => {

              this.clientSelectForm.get('id')?.setValue(client.company.id);
              this.initialClient = client;
            });
        });
    }
  }
  setInitialData(customer: AddClientDto, form: FormGroup) {
    form.get('name')?.setValue(customer.company.name);
    form.get('country')?.setValue(customer.company.country);
    form.get('city')?.setValue(customer.company.city);
    form.get('zipcode')?.setValue(customer.company.zipcode);
    form.get('street')?.setValue(customer.company.street);


    this.dataService.getTagsByUser(customer.company.id as number, "customer").subscribe(tags => {
      this.selectedTags = tags.filter((tag, index, self) =>
        index === self.findIndex((t) => t.ID === tag.ID)
      );
    })
  }

  save() {
    var clientId: number = 0;

    this.dialogService
      .getClientByCompanyId(this.clientSelectForm.get('id')?.value)
      .subscribe((client) => {
        clientId = client.client_id;
        this.dialogFormService
          .saveAddCustomerForm(
            clientId,
            this.companyForm,
            this.selectedTags,
            this.guid
          )
          .subscribe((result: { success: any }) => {
            if (result.success) {
              this.dialogRef.close(result.success);
            }
            return result
          });
      });
  }

  getTagsFromComponent(event: [Tag[]]) {
    this.selectedTags = event[0]
  }
}
